module.exports = __webpack_public_path__ + "static/media/arrow.a74212b6.svg";